const emptyAward = {
  value: '',
  label: '无',
};

export const enum PrizeSource {
  NOT = 0, // 非合成
  FRAGMENT_FUSION = 1, // 碎片合成
}

export const enum AWARD_TYPES {
  NORMAL = '1', // 普通
  MUST = '2', // 必得
  LOTTERY = '3', // 抽奖
  RIGHTS = '4', // 权益
  MULTIPLE_LOTTERY = '5', // 十连抽
  POPUP = '6', // 暑期惊喜弹窗
  LIMITED_RETAIN = '7', // 限时留存
}
export const AWARD_LIST = [
  { value: AWARD_TYPES.NORMAL, label: '普通礼包' },
  { value: AWARD_TYPES.MUST, label: '必得礼包' },
  { value: AWARD_TYPES.LOTTERY, label: '抽奖礼包' },
  { value: AWARD_TYPES.RIGHTS, label: '权益礼包' },
  { value: AWARD_TYPES.LIMITED_RETAIN, label: '限时留存礼包' },
];

export const AWARD_PRIZE_TYPE = {
  AMS: 1, // ams 礼包
  GOODS: 2, // 实物
  NOTHING: 3, // 谢谢参与
  GAME_CURRENCY: 6, // 游戏币
  OUTER_LINK: 4, // 外链
  QB: 7, // q币
  CDKEY: 11, // cdkey
  FRAGMENT: 12, // 碎片
  MARKETING_RESOURCE: 13, // 营销奖励
  CASH: 15, // 现金
};

export const AWARD_PRIZE_TYPE_TEXT_MAP = {
  [AWARD_PRIZE_TYPE.AMS]: 'AMS礼包',
  [AWARD_PRIZE_TYPE.GOODS]: '实物',
  [AWARD_PRIZE_TYPE.QB]: 'Q币',
  [AWARD_PRIZE_TYPE.CDKEY]: 'CDKEY',
};

export const SHOW_STATUS_TYPE_ARRAY = [
  AWARD_PRIZE_TYPE.AMS,
  AWARD_PRIZE_TYPE.GOODS,
  AWARD_PRIZE_TYPE.QB,
  AWARD_PRIZE_TYPE.CASH,
  AWARD_PRIZE_TYPE.CDKEY,
];

export const DELIVER_STATUS = {
  NOT_DELIVER: 0, // 未发货
  DELIVERED: 1, // 已发货
  /**
   * @deprecated This status is deprecated, use other statuses instead.
   */
  DELIVERING: 2, // 含义是发货失败
};

export const REAL_GOODS_LINK = '//h5.flow.qq.com/middlepages/dx_save_address.html';

export const AWARD_FULL_LIST = [...AWARD_LIST, { value: AWARD_TYPES.RIGHTS, label: '权益礼包' }, emptyAward];

export const FREE_LOTTERY_BUTTON_MAP = [
  { value: 'floatbutton', label: '悬浮抽奖按钮' },
  { value: 'hotarea', label: '热区抽奖' },
  { value: 'lotterybutton1', label: '按钮抽奖' },
];

export const ButtonStatus = {
  TO_COMPLETE: 'toComplete',
  TOBE_UNLOCKED: 'tobeUnlocked',
  IN_PROGRESS: 'inProgress',
  TOBE_RECEIVE: 'tobeReceive',
  RECEIVED: 'received',
  TOBE_CHECK: 'tobeCheck',
  EXPIRED: 'expired',
  EMPTY: 'empty',
  FINISHED: 'finished',
};

export const ACT_AWARD_TYPE = {
  MUST: 1,
  LOTTERY: 2,
};

export const ACT_AWARD_TYPE_MAP = [
  { value: ACT_AWARD_TYPE.MUST, label: '必得' },
  { value: ACT_AWARD_TYPE.LOTTERY, label: '抽奖' },
];
